/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Bleeding from './bleeding';
import BleedingDetail from './bleeding-detail';
import BleedingUpdate from './bleeding-update';
import BleedingDeleteDialog from './bleeding-delete-dialog';

const BleedingRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Bleeding />} />
    <Route path="new" element={<BleedingUpdate />} />
    <Route path=":id">
      <Route index element={<BleedingDetail />} />
      <Route path="edit" element={<BleedingUpdate />} />
      <Route path="delete" element={<BleedingDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BleedingRoutes;
